const defaultState = {
    mso: '',
    brandLogos: {
        Comcast: '/assets/images/logos/comcast/comcast_business.svg',
        cox: '/assets/images/logos/partners/cox_business.svg',
        shaw: '/assets/images/logos/partners/shaw.svg',
        wwx1: ''
    },
    msoHostsMap: {
        'vms.cox.com': 'cox',
        'vms.shaw.com': 'shaw',
        'vms.comcast.com': 'Comcast',
        'vms-dev.aceconsole.comcast.net': 'Comcast',
        'vms-qa.aceconsole.comcast.net': 'Comcast',
        localhost: 'Comcast'
    }
};

export const getters = {
    currentMsoLogo(state) {
        return state.brandLogos[state.mso] || '';
    }
};

export const mutations = {
    setMso(state, value) {
        state.mso = value;
    }
};

export const actions = {
    saveMso({ commit, state }, hostname) {
        console.log('calling saveMso', hostname);
        const brandMso = state.msoHostsMap[hostname] || 'Comcast';
        commit('setMso', brandMso);
        localStorage.setItem('brand', JSON.stringify({ mso: brandMso }));
    }
};

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
};
